$(function () {
    $('.swiper-container-rel').each(function (index, element) {
        const $element = $(element); 
        const pagination = $element.find('.swiper-pagination').get(0);

        new Swiper($element.find('.swiper').get(0), { 
            pagination: {
                el: pagination,
                clickable: true,
            },
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },
            watchOverflow: true,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                993: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            },
            
        });
        
    });
    

});